import React from 'react';
import { IonSpinner, IonText } from '@ionic/react';

const LoadingScreen = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <IonSpinner name="crescent" color="dark" style={{ 
        width: '3rem', 
        height: '3rem',
        marginBottom: '1rem' 
      }} />
      <IonText color="dark">
        <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>Loading...</p>
      </IonText>
    </div>
  );
};

export default LoadingScreen; 